import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom'

import { queryClient, registrarRouter } from '@/shared/api/queryClient.js'
import { router } from '@/router.jsx'
import '@/estilos/global.css'

// O handler global de 401 precisa navegar sem ter hooks disponíveis.
registrarRouter(router)

const raiz = document.getElementById('raiz')
if (!raiz) throw new Error('elemento #raiz não encontrado no index.html')

createRoot(raiz).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
)
